var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { DeService, getUniqueIdForSubEntity, } from '@synisys/idm-de-service-client-js';
import { DocumentService, FileType, } from '@synisys/idm-document-service-client-js';
import { Observable } from 'rxjs/Observable';
import { ActionBuilder, ContextArg, ContextArgEnum, FieldArg, StateArg, } from '../layout-actions';
import { KbService, MetaFieldType, } from '@synisys/idm-kb-service-client-js';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { switchMap, tap } from "rxjs/operators";
import { isEmpty, isNil } from "lodash";
var DynamicFormDocumentsService = /** @class */ (function () {
    function DynamicFormDocumentsService(deService, kbService, documentService) {
        this.deService = deService;
        this.kbService = kbService;
        this.documentService = documentService;
    }
    /**
     * Downloads the document
     * @param documentId             document id to download
     * @param documentRootField      document field, if the document is not nested,
     *                                                otherwise first level field (from MainEntity)
     * @param categoryName           category of MainEntity
     * @param entity                 mainEntity
     * @param form                   main form
     * @param fileType
     */
    DynamicFormDocumentsService.prototype.onDownload = function (documentId, documentRootField, categoryName, entity, form, fileType) {
        var _this = this;
        if (fileType === void 0) { fileType = FileType.ORIGINAL; }
        if (form.temporaryDocuments.has(documentId)) {
            // check if document is confirmed
            this.documentService.downloadTempDocument(documentId);
            return;
        }
        this.deService
            .getDocumentToken(categoryName, entity.getInstanceId(), documentRootField)
            .mergeMap(function (token) {
            return _this.documentService.getDownloadUrl(documentId, token);
        })
            .subscribe(function (url) {
            return _this.documentService.downloadDocument(url, fileType);
        }, console.error);
    };
    DynamicFormDocumentsService.prototype.downloadByUrl = function (url, fileType) {
        if (fileType === void 0) { fileType = FileType.ORIGINAL; }
        this.documentService.downloadDocument(url, fileType);
    };
    /**
     * returns Observable of document's URL
     * @param documentId             document id to download
     * @param documentRootField      document field, if the document is not nested,
     *                                               first level field (from MainEntity) otherwise
     * @param categoryName           category of MainEntity
     * @param entity                 mainEntity
     * @param form                   main form
     */
    DynamicFormDocumentsService.prototype.getDownloadUrl = function (documentId, documentRootField, categoryName, entity, form) {
        var _this = this;
        if (form.temporaryDocuments.has(documentId)) {
            return this.documentService.getTempDocumentUrl(documentId);
        }
        return this.deService
            .getDocumentToken(categoryName, entity.getInstanceId(), documentRootField)
            .mergeMap(function (token) {
            return _this.documentService.getDownloadUrl(documentId, token);
        });
    };
    /**
     * removes document by documentId from the temporary documents (if exist). if the parent entity and the field of
     *                                                                this document are given then removes from entity
     * @param documentId             document id to remove
     * @param form                   form interface
     * @param documentEntity         parent entity
     * @param documentEntityField    document field
     */
    DynamicFormDocumentsService.prototype.removeDocument = function (documentId, form, documentEntity, documentEntityField) {
        if (form.temporaryDocuments.has(documentId)) {
            form.temporaryDocuments.delete(documentId);
        }
        if (documentEntity &&
            documentEntity.getProperty(documentEntityField).value ===
                documentId) {
            documentEntity.getProperty(documentEntityField).value = null;
        }
    };
    /**
     * sets value to given entity, and saves for confirming
     * @param documentId             documentId
     * @param documentEntity         document's parent entity
     * @param documentEntityField    document's field
     * @param form                   main form
     * @param close                  if need to close popup
     */
    DynamicFormDocumentsService.prototype.submitNestedDocument = function (documentId, documentEntity, documentEntityField, form, close) {
        documentEntity.getProperty(documentEntityField).value = documentId;
        form.temporaryDocuments.add(documentId);
        if (close) {
            form.activePopup.close();
        }
    };
    DynamicFormDocumentsService.prototype.confirmDocumentsUploadAndReset = function (mainEntity, form) {
        var _this = this;
        return this.confirmDocumentsUpload(mainEntity, form)
            .pipe(switchMap(function (info) {
            form.temporaryDocuments = new Set();
            if (form.temporaryDocumentsOld &&
                form.temporaryDocumentsOld.length > 0) {
                return _this.confirmDocumentsUploadOld(mainEntity, form).pipe(tap(function () { return form.temporaryDocumentsOld = []; }));
            }
            return Observable.of([]);
        }));
    };
    DynamicFormDocumentsService.prototype.getActions = function () {
        var _this = this;
        var result = [];
        result.push(new ActionBuilder()
            .name('onDownload')
            .params([
            ContextArg(ContextArgEnum.EVENT),
            StateArg('documentRootField'),
            ContextArg(ContextArgEnum.CATEGORY),
            ContextArg(ContextArgEnum.ENTITY),
            ContextArg(ContextArgEnum.FORM),
        ])
            .action(function (documentId, documentRootField, categoryName, entity, form, fileType) {
            if (fileType === void 0) { fileType = FileType.ORIGINAL; }
            return _this.onDownload(documentId, documentRootField, categoryName, entity, form, fileType);
        })
            .build());
        result.push(new ActionBuilder()
            .name('getDownloadUrl')
            .params([
            ContextArg(ContextArgEnum.EVENT),
            StateArg('documentRootField'),
            ContextArg(ContextArgEnum.CATEGORY),
            ContextArg(ContextArgEnum.ENTITY),
            ContextArg(ContextArgEnum.FORM),
        ])
            .action(function (documentId, documentRootField, categoryName, entity, form) {
            return _this.getDownloadUrl(documentId, documentRootField, categoryName, entity, form);
        })
            .build());
        result.push(new ActionBuilder()
            .name('downloadByUrl')
            .params([StateArg('url')])
            .action(function (url, fileType) {
            if (fileType === void 0) { fileType = FileType.ORIGINAL; }
            return _this.downloadByUrl(url, fileType);
        })
            .build());
        result.push(new ActionBuilder()
            .name('removeDocument')
            .params([
            ContextArg(ContextArgEnum.EVENT),
            ContextArg(ContextArgEnum.FORM),
            ContextArg(ContextArgEnum.CONTEXT_ENTITY),
            FieldArg('field-name'),
        ])
            .action(function (documentId, form, entity, fieldName) {
            return _this.removeDocument(documentId, form, entity, fieldName);
        })
            .build());
        result.push(new ActionBuilder()
            .name('removeNestedDocument')
            .params([
            ContextArg(ContextArgEnum.EVENT),
            ContextArg(ContextArgEnum.FORM),
            ContextArg(ContextArgEnum.ITEM),
            StateArg('documentEntityField'),
        ])
            .action(function (documentId, form, documentEntity, documentEntityField) {
            return _this.removeDocument(documentId, form, documentEntity, documentEntityField);
        })
            .build());
        result.push(new ActionBuilder()
            .name('submitDocument')
            .params([
            ContextArg(ContextArgEnum.EVENT),
            FieldArg('field-name'),
            ContextArg(ContextArgEnum.FORM),
            StateArg('close'),
        ])
            .action(function (documentId, fieldName, form, close) {
            return _this.submitNestedDocument(documentId, form.entity, fieldName, form, close);
        })
            .build());
        result.push(new ActionBuilder()
            .name('submitNestedDocument')
            .params([
            ContextArg(ContextArgEnum.EVENT),
            ContextArg(ContextArgEnum.CONTEXT_ENTITY),
            FieldArg('field-name'),
            ContextArg(ContextArgEnum.FORM),
            StateArg('close'),
        ])
            .action(function (documentId, documentEntity, documentEntityField, form, close) {
            return _this.submitNestedDocument(documentId, documentEntity, documentEntityField, form, close);
        })
            .build());
        this.addOldActions(result);
        return result;
    };
    DynamicFormDocumentsService.prototype.confirmDocumentsUpload = function (mainEntity, form) {
        var _this = this;
        return !isNil(form.temporaryDocuments) && !isEmpty(form.temporaryDocuments) ? Observable.zip.apply(Observable, Array.from(form.temporaryDocuments).map(function (docId) {
            return _this.documentService.confirmUpload(docId, mainEntity.getInstanceId());
        })) : Observable.of([]);
    };
    // <editor-fold desc="Old Actions">
    DynamicFormDocumentsService.prototype.addOldActions = function (result) {
        var _this = this;
        result.push(new ActionBuilder()
            .name('submitDocumentOld')
            .action(function (event, documentSystemName, form, close) {
            _this.upload(form.categorySystemName, documentSystemName, event.file).subscribe(function (documentInfo) {
                form.entity.getProperty(documentSystemName).value = documentInfo.id;
                form.temporaryDocumentsOld.push(new TemporaryDocument(documentInfo, MetaFieldType.DOCUMENT, null, documentSystemName));
                if (close) {
                    form.activePopup.close();
                }
            }, console.error);
        })
            .build());
        result.push(new ActionBuilder()
            .name('submitNestedDocumentOld')
            .action(function (event, documentEntity, fieldSystemName, documentSystemName, form, categoryName, entity, close) {
            categoryName = categoryName || form.categorySystemName;
            entity = entity || form.entity;
            _this.kbService
                .getMetaFields(categoryName)
                .map(function (metaFields) {
                return metaFields.find(function (metaField) {
                    // find metaField which contains document
                    return (metaField.getSystemName() ===
                        fieldSystemName);
                });
            })
                .mergeMap(function (containerMetaField) {
                return _this.upload(containerMetaField.getCompoundCategorySystemName(), documentSystemName, event.file).map(function (documentInfo) {
                    documentEntity.getProperty(documentSystemName).value = documentInfo.id;
                    _this.setDocumentValueToEntity(containerMetaField, documentEntity, entity);
                    _this.addToTemporaryDocuments(containerMetaField, documentInfo, documentSystemName, form);
                });
            })
                .subscribe(function () {
                if (close) {
                    form.activePopup.close();
                }
            }, console.error);
        })
            .build());
        result.push(new ActionBuilder()
            .name('onDownloadOld')
            .action(function (documentId, systemName, form, fileType) {
            if (fileType === void 0) { fileType = FileType.ORIGINAL; }
            var document = form.temporaryDocumentsOld.find(function (tempDoc) {
                return tempDoc.info.id === documentId;
            });
            if (document === undefined) {
                // check if document is confirmed
                _this.deService
                    .getDocumentToken(form.categorySystemName, form.entity.getInstanceId(), systemName)
                    .mergeMap(function (token) {
                    return _this.documentService.getDownloadUrl(documentId, token);
                })
                    .subscribe(function (url) {
                    _this.documentService.downloadDocument(url, fileType);
                }, console.error);
            }
            else {
                return _this.documentService.downloadTempDocument(documentId);
            }
        })
            .build());
        result.push(new ActionBuilder()
            .name('getDownloadUrlOld')
            .action(function (documentId, systemName, form) {
            var document = form.temporaryDocumentsOld.find(function (tempDoc) {
                return tempDoc.info.id === documentId;
            });
            var downloadUrl = new ReplaySubject(1);
            if (document === undefined) {
                _this.deService
                    .getDocumentToken(form.categorySystemName, form.entity.getInstanceId(), systemName)
                    .mergeMap(function (token) {
                    return _this.documentService.getDownloadUrl(documentId, token);
                })
                    .subscribe(function (url) { return downloadUrl.next(url); }, console.error);
            }
            else {
                _this.documentService
                    .getTempDocumentUrl(documentId)
                    .subscribe(function (url) { return downloadUrl.next(url); }, console.error);
            }
            return downloadUrl;
        })
            .build());
        result.push(new ActionBuilder()
            .name('removeDocumentOld')
            .action(function (documentId, form) {
            var documentIndex = form.temporaryDocumentsOld.findIndex(function (tempDoc) {
                return tempDoc.info.id === documentId;
            });
            if (documentIndex !== -1) {
                var document_1 = form.temporaryDocumentsOld[documentIndex];
                if (document_1.entitySystemName === null) {
                    form.entity.getProperty(document_1.documentSystemName).value = null;
                }
                else {
                    _this.kbService
                        .getMetaFields(form.categorySystemName)
                        .subscribe(function (metaFields) {
                        var metaField = metaFields.find(function (mf) {
                            return (mf.getSystemName() ===
                                document_1.entitySystemName);
                        });
                        _this.removeDocumentValueFromEntity(metaField, document_1, form);
                    }, console.error);
                }
                form.temporaryDocumentsOld.splice(documentIndex, 1);
            }
        })
            .build());
        return result;
    };
    DynamicFormDocumentsService.prototype.confirmDocumentsUploadOld = function (mainEntity, form) {
        var _this = this;
        return Observable.zip.apply(Observable, form.temporaryDocumentsOld.map(function (doc) {
            var document;
            switch (doc.type) {
                case MetaFieldType.MULTI_SELECT:
                case MetaFieldType.SUB_ENTITY:
                    document = mainEntity
                        .getProperty(doc.entitySystemName)
                        .value.find(function (entity) {
                        return (entity.getProperty(doc.documentSystemName).value === doc.info.id);
                    });
                    if (document) {
                        return _this.documentService.confirmUpload(doc.info.id, mainEntity.getInstanceId());
                    }
                    else {
                        return Observable.of(null);
                    }
                case MetaFieldType.DOCUMENT:
                    return _this.documentService.confirmUpload(doc.info.id, mainEntity.getInstanceId());
                case MetaFieldType.CLASSIFIER:
                    document = mainEntity.getProperty(doc.entitySystemName).value;
                    if (document.getProperty(doc.documentSystemName)
                        .value === doc.info.id) {
                        return _this.documentService.confirmUpload(doc.info.id, mainEntity.getInstanceId());
                    }
                    else {
                        return Observable.of(null);
                    }
                default:
                    throw new TypeError("Unsupported type " + doc.type + " for document!");
            }
        }));
    };
    DynamicFormDocumentsService.prototype.upload = function (categorySystemName, fieldSystemName, file) {
        return this.documentService.upload(categorySystemName + "." + fieldSystemName, file.name, file);
    };
    DynamicFormDocumentsService.prototype.setDocumentValueToEntity = function (documentMetaField, document, entity) {
        switch (documentMetaField.getType()) {
            case MetaFieldType.CLASSIFIER:
                entity.getProperty(documentMetaField.getSystemName()).value = document;
                return;
            case MetaFieldType.MULTI_SELECT:
                var list = entity.getProperty(documentMetaField.getSystemName()).value;
                if (list.find(function (item) { return item.getId() === document.getId(); }) === undefined) {
                    list.push(document);
                }
                return;
            case MetaFieldType.SUB_ENTITY:
                var subEntities = entity.getProperty(documentMetaField.getSystemName()).value;
                if (subEntities.find(function (item) { return item.getId() === document.getId(); }) === undefined) {
                    var subEntity = document;
                    subEntity.setId(getUniqueIdForSubEntity(entity, documentMetaField.getSystemName()));
                    subEntities.push(subEntity);
                }
                return;
            default:
                throw new TypeError(documentMetaField
                    .getType()
                    .toString() + " type not supported for document");
        }
    };
    DynamicFormDocumentsService.prototype.removeDocumentValueFromEntity = function (documentMetaField, document, form) {
        switch (documentMetaField.getType()) {
            case MetaFieldType.CLASSIFIER: {
                form.entity.getProperty(document.entitySystemName).value = null;
                return;
            }
            case MetaFieldType.MULTI_SELECT: {
                var documentIndex = form.entity
                    .getProperty(document.entitySystemName)
                    .value.findIndex(function (entity) {
                    return (entity.getProperty(document.documentSystemName).value === document.info.id);
                });
                if (documentIndex !== -1) {
                    form.entity
                        .getProperty(document.entitySystemName)
                        .value.splice(documentIndex, 1);
                }
                return;
            }
            case MetaFieldType.SUB_ENTITY: {
                form.entity
                    .getProperty(document.entitySystemName)
                    .value.some(function (entity) {
                    if (entity.getProperty(document.documentSystemName).value === document.info.id) {
                        entity.getProperty(document.documentSystemName).value = null;
                        return true;
                    }
                    return false;
                });
                return;
            }
            default:
                throw new TypeError(documentMetaField
                    .getType()
                    .toString() + " type not supported for document");
        }
    };
    DynamicFormDocumentsService.prototype.addToTemporaryDocuments = function (metaField, info, documentSystemName, form) {
        form.temporaryDocumentsOld.push(new TemporaryDocument(info, metaField.getType(), metaField.getSystemName(), documentSystemName));
    };
    DynamicFormDocumentsService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [DeService,
            KbService,
            DocumentService])
    ], DynamicFormDocumentsService);
    return DynamicFormDocumentsService;
}());
export { DynamicFormDocumentsService };
/* tslint:disable:max-classes-per-file */
var TemporaryDocument = /** @class */ (function () {
    function TemporaryDocument(info, type, entitySystemName, documentSystemName) {
        this.info = info;
        this.type = type;
        this.entitySystemName = entitySystemName;
        this.documentSystemName = documentSystemName;
    }
    return TemporaryDocument;
}());
export { TemporaryDocument };
/* tslint:enable:max-classes-per-file */
//# sourceMappingURL=dynamic-form-documents.service.js.map